import React, { useState } from "react";
import { stateDetails, updateImisState } from "./config";
import { NavLink } from "react-router-dom";

function Header(props) {

  // const [textValue, setTextValue] = useState("");

  let ChapterCode = props.userState;
  if (ChapterCode == "WA") {
    ChapterCode = "";
  }

  // const handleInputChange = (event) => {
  //   const value = event.target.value;
  //   setTextValue(value);
  //   console.log("Input value:", value);
    
  //   // Update imisState when "QLD" is entered
  //   if (value === "QLD") {
  //     updateImisState("QLD");
  //     console.log("QLD added to imisState");
  //   }
  // };
  return (
    <div className="row margin-top">
      <div className="large-6 columns">
        <header className="App-header">
          <h1 className="ama-logo">
            <NavLink to="/">
              <img
                src="https://www.ama.com.au/sites/default/files/2020-03/ama-logo.png"
                alt="AMA Logo"
              />
            </NavLink>
          </h1>
          {/* <input
          type="text"
          id="tField"
          value={textValue}
          onChange={handleInputChange}
          placeholder="Enter text here"
          style={{ opacity: 0 }}
          onFocus={(e) => {
            e.target.style.opacity = '1';
            e.target.style.border = '2px solid #333';
          }}
          onBlur={(e) => {
            e.target.style.opacity = '0';
          }}
        /> */}
        </header>
      </div>
      <div className="large-6 columns">
        <h3 className="right float-right align-right text-muted">
          Become a Member
        </h3>
        
        {ChapterCode && (
          <small className="float-right align-right">
            {ChapterCode === "QLD"
              ? "Welcome to the Queensland Branch of the Australian Medical Association – if you need assistance, please call our Membership team on 1300 133 655"
              : "If you are having trouble, please contact " + ChapterCode + " member services on " + stateDetails[ChapterCode]["phone"]}
            {/* If you are having trouble, please contact {ChapterCode} member
            services on {stateDetails[ChapterCode]["phone"]} */}
          </small>
        )}
        {ChapterCode == "NT" && (
          <p class="float-right text-right">
            <b>
              If you are joining as a member of AMA NT you automatically receive
              free membership to ASMOF NT.
            </b>
          </p>
        )}
      </div>
    </div>
  );
}

export default Header;
